export function isFileDraft(file) {
  if (!file) return false
  return Boolean(file.is_draft) || String(file.status ?? '').toLowerCase() === 'draft'
}

function isFinalizedFlag(file) {
  if (!file) return false
  if (Boolean(file.is_finalized)) return true
  return String(file.role ?? file.document_role ?? '').toLowerCase() === 'finalized'
}

export function sortPolicyFiles(files = []) {
  return [...files].sort((a, b) => {
    const aDraft = isFileDraft(a)
    const bDraft = isFileDraft(b)
    if (aDraft !== bDraft) return aDraft ? -1 : 1

    const aFinal = isFinalizedFlag(a)
    const bFinal = isFinalizedFlag(b)
    // Keep working copies above finalized PDFs in the list.
    if (aFinal !== bFinal) return aFinal ? 1 : -1

    const aTime = new Date(a.created_at || a.updated_at || 0).getTime()
    const bTime = new Date(b.created_at || b.updated_at || 0).getTime()
    return bTime - aTime
  })
}

export function getActivePolicyFileLabel(file) {
  if (isFinalizedFlag(file)) return 'Finalized'
  if (isFileDraft(file)) return 'Draft'
  return 'Recently Uploaded'
}

export function isActivePolicyFile(index) {
  return index === 0
}

export function canEditPolicyFile(index) {
  return isActivePolicyFile(index)
}

export function normalizeFileForEditor(file) {
  if (!file) return file
  return {
    ...file,
    file_link: file.file_link || file.file_path || file.url || '',
  }
}

/**
 * Normalize FileUploader `v-model` to a single browser `File`.
 * FileUploader emits a File when `multiple=false`; older callers may still store `[File]`.
 */
export function resolveUploadedFile(value) {
  if (!value) return null
  if (value instanceof File) return value
  if (Array.isArray(value)) {
    const first = value.find((item) => item instanceof File)
    return first ?? null
  }
  return null
}

/** True for a server-persisted upload (has a fetchable url/name) rather than a raw browser File. */
export function isStoredFile(file) {
  if (!file || typeof file !== 'object' || file instanceof File) return false
  return !!(
    file.url ||
    file.file_path ||
    file.path ||
    file.original_name ||
    file.file_name ||
    file.display_name
  )
}

export function storedFileName(file) {
  return file?.display_name || file?.original_name || file?.file_name || file?.name || 'Document'
}

export function storedFileUrl(file) {
  return file?.url || file?.file_path || file?.path || ''
}
